export default __webpack_public_path__ + "static/BgCover-ea7302fda9f676cc773f992e17d309c9.png";